import React from "react";
import { Card, Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import QualificationList from "./QualificationList";

const Qualification = () => {
    const breadcrumbItems = [
        { title: "Settings", link: "" },
        { title: "Qualification", link: "/settings/qualification" },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb items={breadcrumbItems} />
                    <Card>
                        <QualificationList />
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Qualification;


